export default {"src":"/_next/static/media/image-desk.7d026a89.svg","height":449,"width":1181,"blurWidth":0,"blurHeight":0};